/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Approvedonly2Inputs */

const en_coinvestments_prospects_approvedonly2 = /** @type {(inputs: Coinvestments_Prospects_Approvedonly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approved Only`)
};

/**
* | output |
* | --- |
* | "Approved Only" |
*
* @param {Coinvestments_Prospects_Approvedonly2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_approvedonly2 = /** @type {((inputs?: Coinvestments_Prospects_Approvedonly2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Approvedonly2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_approvedonly2(inputs)
});
export { coinvestments_prospects_approvedonly2 as "coInvestments_prospects_approvedOnly" }